module.exports = __webpack_public_path__ + "static/media/user.3ddde79b.svg";